const getFilterPreviousDefectData = (params) => {
  const { defectData, trailerDefect, tractorDefect, dollyDefect } = params;
  const {
    updatedTrailerDefectList,
    updatedTractorDefectList,
    updatedDollyDefectList,
  } = defectData;
  let [newTrailerDefectList, newTractorDefectList, newDollyDefectList] = [
    trailerDefect,
    tractorDefect,
    dollyDefect,
  ];
  if (updatedTrailerDefectList.length !== 0) {
    newTrailerDefectList = [
      ...trailerDefect.filter(
        (defect) =>
          defect.equipId !== updatedTrailerDefectList[0]?.equipId,
      ),
      ...updatedTrailerDefectList,
    ];
  }
  if (updatedTractorDefectList.length !== 0) {
    newTractorDefectList = [
      ...tractorDefect.filter(
        (defect) =>
          defect.equipId !== updatedTractorDefectList[0]?.equipId,
      ),
      ...updatedTractorDefectList,
    ];
  }
  if (updatedDollyDefectList.length !== 0) {
    newDollyDefectList = [
      ...dollyDefect.filter(
        (defect) => defect.equipId !== updatedDollyDefectList[0]?.equipId,
      ),
      ...updatedDollyDefectList,
    ];
  }

  return {
    newTrailerDefectList,
    newTractorDefectList,
    newDollyDefectList,
  };
};

const getMappedDefectData = ({
  equipmentData,
  equipmentNumber,
  equipId,
  equipmentScac,
}) => {
  if (!equipmentData || equipmentData.length === 0) {
    return [];
  }
  return equipmentData.reduce((acc, equipItem) => {
    if (!equipItem?.defects || equipItem?.defects?.length === 0) {
      return acc;
    }
    acc = [
      ...acc,
      ...equipItem.defects.map((defect) => ({
        ...defect,
        equipNumber: equipItem[equipmentNumber],
        equipId: equipItem[equipId],
        scacCode: equipItem[equipmentScac],
      })),
    ];
    return acc;
  }, []);
};

export { getFilterPreviousDefectData, getMappedDefectData };
